var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-table__body__row orders-table-row",class:[
    {
      read: _vm.orderData.userRead,
      processed: _vm.orderData.userProcessed,
    },
  ]},[(this.$store.state.user.user.portalID === '0')?_c('div',{staticClass:"v-table__body__row__data orders-table-row__data--first-column"},[_c('span',{staticClass:"orders-table-row__data--first-column__content"},[_vm._v(" "+_vm._s(_vm.orderData.dobavljac)+" ")])]):_vm._e(),_c('div',{staticClass:"v-table__body__row__data"},[_vm._v(_vm._s(_vm.orderData.broj))]),_c('div',{staticClass:"v-table__body__row__data"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.orderData.datum)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }